import { FC, useState } from 'react';
import { Modal } from 'antd';

// Shared UI Library Components
import { CustomButton } from '@ppmcore/seven-ppm-core-shared-components-react';

// Styles
import './recording-video-call-modal.scss';

interface IRecordingVideoCallModalProps {
  open: boolean;
  activeRecordingCallLink: string;
  onCancel?: () => void;
}

export const RecordingVideoCallModal: FC<IRecordingVideoCallModalProps> = (
  {
    open = false,
    activeRecordingCallLink,
    onCancel = () => {}
  }: IRecordingVideoCallModalProps
) => {

  const [linkError, setLinkError] = useState(false);

  const handleCancel = (): void => {
    onCancel();
  };

  const handleVideoError = () => {
    setLinkError(true);
};

  return (
    <Modal
      rootClassName="recording-video-call-modal"
      width={ '604px' }
      open={ open }
      closeIcon={ null }
      centered={ true }
      title={ 'Call Recording' }
      footer={ [
        <CustomButton key="cancel" text={ 'Close' } type={ 'text' } onClick={ handleCancel }/>
      ] }
      onCancel={ handleCancel }
    >
      <div className="modal-body">
        <video
          className="video-player"
          controls
          controlsList="noplaybackrate"
          disablePictureInPicture
          preload="auto"
          data-setup="{}"
          playsInline
          onError={ handleVideoError }
        >
          <source src={ activeRecordingCallLink } type="video/mp4" />
          <p className="vjs-no-js">
            To view this video please enable JavaScript, and consider upgrading to a web browser that
            <a href="https://videojs.com/html5-video-support/" target="_blank" >supports HTML5 video</a>
          </p>
        </video>

        { linkError && <div className="link-error">Sorry, an error occurred while trying to load the file.</div> }
      </div>
    </Modal>
  )
};
